import { render, staticRenderFns } from "./m_changesign.vue?vue&type=template&id=605f83fc&scoped=true&"
import script from "./m_changesign.vue?vue&type=script&lang=js&"
export * from "./m_changesign.vue?vue&type=script&lang=js&"
import style0 from "./m_changesign.vue?vue&type=style&index=0&id=605f83fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f83fc",
  null
  
)

export default component.exports